import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { MARKET } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { safeLazy } from '@/common/utils/import';
import { Redirect } from 'expo-router';

const { SubmitChildcareVoucher } = safeLazy(
  () => import('@/web/containers/Benefits/Benefits')
);

const { ESPayChildcarePage } = safeLazy(
  () => import('@/web/containers/Dashboard/ESWalletDashboard/ESWalletDashboard')
);

export default function ChildcarePayPage() {
  const { company } = useEmployeeDetails();
  switch (company.market.slug) {
    case MARKET.PT:
      return (
        <RouterSuspense>
          <SubmitChildcareVoucher />
        </RouterSuspense>
      );
    case MARKET.ES:
      return (
        <RouterSuspense>
          <ESPayChildcarePage />
        </RouterSuspense>
      );
    default:
      return <Redirect href={ROUTES.NOT_FOUND} />;
  }
}
